"use client";

import { useId, useRef } from "react";
import FloatingTooltipContent from "@/components/ui/floating-tooltip-content";
import { useFloatingTooltip } from "@/components/ui/use-floating-tooltip";
import { cn } from "@/lib/utils";

export default function InlineTooltip({
  label,
  text,
  className,
}: {
  label: string;
  text: string;
  className?: string;
}) {
  const tooltipId = useId();
  const triggerRef = useRef<HTMLSpanElement>(null);
  const { mounted, visible, position, open, close } =
    useFloatingTooltip(triggerRef);

  return (
    <>
      <span
        ref={triggerRef}
        tabIndex={0}
        role="button"
        aria-describedby={mounted && visible ? tooltipId : undefined}
        className={cn(
          "cursor-help border-b border-dashed border-current",
          className,
        )}
        onMouseEnter={open}
        onMouseLeave={close}
        onFocus={open}
        onBlur={close}
      >
        {label}
      </span>
      <FloatingTooltipContent
        id={tooltipId}
        text={text}
        position={position}
        visible={visible}
        mounted={mounted}
      />
    </>
  );
}
